const UnauthorizedMessage = ({ currentUser }) => {
	return currentUser ? (
		<div>
			<p>
				<strong>
					The currently logged in user is unauthorized to use this
					page.
				</strong>
			</p>
			<p>
				If you believe you are to be authorized to use the Application
				Management Tool and are seeing this error by mistake, please
				contact IMS support
			</p>
			<p>
				Authorized roles at this time only include roles allocated to
				IMS development team
			</p>
		</div>
	) : null;
};

export default UnauthorizedMessage;
